import { translate } from '../i18n'
import { StringValidator } from './StringValidator'

export class NoClipValidator extends StringValidator {
    isValidString = (value: string) => {
        return !value.toLowerCase().includes('clip')
    }

    getMessage = () => translate('validations.no_clip') as string
}
